import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Ispettorato } from 'src/app/models/ispettorato';
import { IspettoratoService } from 'src/app/services/ispettorato.service';
import { BaseEditForm } from 'src/app/shared/baseEditForm';
import { findInRoute } from 'src/app/shared/utilities';

@Component({
  selector: 'ispettorati-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class IspettoratiFormComponent extends BaseEditForm implements OnInit {

  ispettorato: Ispettorato;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private ispettoratoService: IspettoratoService,
    @Optional() public dialogRef: MatDialogRef<IspettoratiFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Ispettorato,) {
    super();
    this.ispettorato = data;
  }

  async ngOnInit() {
    const idIspettorato = findInRoute('idIspettorato', this.route);
    if (idIspettorato) {
      this.ispettorato = await this.ispettoratoService.getOne(+idIspettorato, ['compagnia', 'agenzia', 'tipo_ispettorato']);
    }

    this.form = this.fb.group({
      nome: [this.ispettorato?.nome, Validators.required],
      codice: [this.ispettorato?.codice],
      compagnia: [this.ispettorato?.compagnia],


      via: [this.ispettorato?.via],
      civico: [this.ispettorato?.civico],
      comune: [this.ispettorato?.comune],
      tel: [this.ispettorato?.tel],
      fax: [this.ispettorato?.fax],
      cell: [this.ispettorato?.cell],
      email: [this.ispettorato?.email],

    });
  }


}

